export default "__VITE_ASSET__15787964__"